'use strict';

exports.__esModule = true;
exports.default = Comments;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Parser = require('./Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _getCurrentHref = require('./utils/getCurrentHref');

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

var _ColorScheme = require('./constants/ColorScheme');

var _ColorScheme2 = _interopRequireDefault(_ColorScheme);

var _CommentsOrderBy = require('./constants/CommentsOrderBy');

var _CommentsOrderBy2 = _interopRequireDefault(_CommentsOrderBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Comments(props) {
  var className = props.className,
      colorScheme = props.colorScheme,
      _props$href = props.href,
      href = _props$href === undefined ? (0, _getCurrentHref2.default)() : _props$href,
      numPosts = props.numPosts,
      orderBy = props.orderBy,
      width = props.width,
      children = props.children,
      onParse = props.onParse,
      mobile = props.mobile;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-comments',
        'data-colorscheme': colorScheme,
        'data-numposts': numPosts,
        'data-href': href,
        'data-order-by': orderBy,
        'data-width': width,
        'data-skin': colorScheme,
        'data-mobile': mobile
      },
      children
    )
  );
}


Comments.defaultProps = {
  href: undefined,
  numPosts: undefined,
  orderBy: undefined,
  width: undefined,
  colorScheme: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined,
  mobile: undefined
};
//# sourceMappingURL=Comments.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/Comments.js
// module id = 853
// module chunks = 67997519577666